<template>
    <!--
           作者：kmdshop
           时间：2020-06-20
           描述：diy组件-模拟显示-商品栏
       -->
     <div class="drag optional" :class="{ selected: index === selectedIndex }" @click.stop="$parent.$parent.onEditer(index)">
       <div class="diy-product" :style="{ background: item.style.background }">
         <div :class="['display__' + item.style.display]" style="height: 100px;line-height: 100px;text-align: center;">
           新商品
          </div>
       </div>
       <div class="btn-edit-del">
         <div class="btn-del" @click.stop="$parent.$parent.onDeleleItem(index)">删除</div>
       </div>
     </div>
   </template>
   
   <script>
     import HproductApi from '@/api/hproduct.js';
     export default {
       data() {
         return {
           /*商品列表*/
           tableData: {},
           /*分类id*/
           category_id: 0,
           product:[]
         };
       },
   
       created() {
         /*获取列表*/
         this.getData();
         this.product = this.item.data;
       },
       // props: ['item', 'index', 'selectedIndex'],
       props: {
         index: Number,
         item: Object,
         selectedIndex:Number
       },
       watch:{
         item:{
           handler(new_value,old_value){
             var self = this;
             setTimeout(() => {
               var data = new_value.data
               var new_arr = [];
               if(data.length > 2){
                 for(var i=0;i<data.length;i++){
                   if(data[i].product_name != "此处显示商品名称"){
                     new_arr.push(data[i]);
                   }
                 }
               }else{
                 new_arr =data;
               }
               self.product = new_arr;
             }, 300);
           },
           deep: true
       }
       },
       methods: {
         getData() {
           let self = this;
          
        
       
           HproductApi.productList({
               category_id: self.category_id
             }, true).then(res => {
               console.log("走了吗", res.data.list.data)
               self.tableData = res.data.list.data;
             })
             .catch(error => {
               self.loading = false;
             });
         },
   
         /*计算宽度*/
         getUlwidth(item){
           if(item.style.display=='slide'){
              let total=0;
             if(item.params.source=='choice'){
                total=item.data.length;
             }else{
               total=item.defaultData.length;
             }
             let w=0;
             if(item.style.column==2){
               w=total*150;
             }else{
               w=total*100;
             }
              return 'width:'+w+'px;';
           }
         }
       }
     };
   </script>
   
   <style>
     .diy-product .product-list.column__1 .product-item {
       padding: 10px;
       border-bottom: 1px solid #dddddd;
       background: #FFFFFF;
     }
   
     .diy-product .product-list.column__1 .product-item-box {
       display: flex;
       justify-content: flex-start;
       align-items: stretch;
     }
     .diy-product .display__slide{
       overflow-x: auto;
     }
     .diy-product .display__slide .product-list{display: flex;
       justify-content: flex-start;}
     .diy-product .display__slide .product-list.column__2 .product-item{
       width: 150px;
     }
     .diy-product .display__slide .product-list.column__3 .product-item{
       width: 100px;
     }
   .diy-product .display__slide .product-list .product-item{ margin-right: 10px;}
     .diy-product .product-list img {
       width: 100%;
     }
   
     .diy-product .product-list.column__1 .product-cover {
       width: 100px;
       height: 100px;
     }
   
     .diy-product .product-list.column__1 .product-info {
       margin-left: 10px;
       flex: 1;
       display: flex;
       flex-direction: column;
       justify-content: space-between;
     }
   
     .diy-product .product-list .product-title {
       margin-top: 4px;
       height: 40px;
       line-height: 20px;
       display: -webkit-box;
       overflow: hidden;
       -webkit-line-clamp: 2;
       -webkit-box-orient: vertical;
   
     }
   
     .diy-product .display__list .column__2,
     .diy-product .display__list .column__3 {
       display: flex;
       flex-wrap: wrap;
       justify-content: space-between;
     }
   
     .diy-product .product-list.column__2 .product-item {
       width:170px;
       margin-bottom: 10px;
       background: #FFFFFF;
     }
     .diy-product .product-list.column__2 .product-item .product-cover{
       width: 170px;
       height: 170px;
       overflow: hidden;
     }
   
     .diy-product .product-list.column__3 .product-item {
       width: 117px;
       margin-bottom: 10px;
       background: #FFFFFF;
     }
      .diy-product .product-list.column__3 .product-item .product-cover{
       width: 117px;
       height: 117px;
       overflow: hidden;
      }
      .diy-product .product-list.column__3 .product-item .product-cover img{
        width: 117px;
      }
   
     .diy-product .product-list.column__2 .product-title,
     .diy-product .product-list.column__3 .product-title {
       height: 40px; overflow: hidden;
     }
   </style>
   


// WEBPACK FOOTER //
// src/views/page/page/diy/model/Nproduct.vue